export default "__VITE_ASSET__CjLypWJd__"